import { ApiError, PaginatedCollection } from '@/api/types'
import { SortDirection } from '@/entities/sort'
import { PaidWithdrawModel } from '../../model'
import { getColumnsCompleted } from '../../table'
import { MobileBlockTraderWithdraw } from '../mobile/mobileBlocks/MobileBlockTraderWithdraw'
import { ManageReceiptsDialog } from '../../dialogs'
import { useState } from 'react'
import { BaseTable, BaseTableSkeleton } from 'syncra-storybook/features'

export const CompletedPanel = ({
  isPaidWithdrawLoading,
  methods,
  skip,
  paidWithdrawsData,
  paidWithdrawsError,
  sort,
  toggleSort,
  showRate,
}: {
  paidWithdrawsData: PaginatedCollection<PaidWithdrawModel[]> | undefined
  paidWithdrawsError: ApiError | null
  isPaidWithdrawLoading: boolean
  methods: {
    handlePageChange: (newSkip: number) => void
  }
  skip?: number
  sort?: {
    sortCreatedAt?: SortDirection
    sortAmountTo?: SortDirection
  }
  toggleSort?: (key: 'sortCreatedAt' | 'sortAmountTo') => void,
  showRate: boolean,
}) => {
  const [selectedWithdrawId, setSelectedWithdrawId] = useState<string | null>(null)
  const [isReceiptsDialogOpen, setIsReceiptsDialogOpen] = useState(false)

  const handleManageReceipts = (withdrawId: string) => {
    setSelectedWithdrawId(withdrawId)
    setIsReceiptsDialogOpen(true)
  }

  const handleCloseReceiptsDialog = () => {
    setIsReceiptsDialogOpen(false)
    setSelectedWithdrawId(null)
  }
  return (
    <div className="mt-8">
      {paidWithdrawsError ? (
        <p>Ошибка загрузки данных.</p>
      ) : isPaidWithdrawLoading ? (
        <BaseTableSkeleton />
      ) : !paidWithdrawsData?.items || paidWithdrawsData.items?.length === 0 ? (
        <p>Исходящих заявок нет.</p>
      ) : (
        <>
          <BaseTable
            columns={getColumnsCompleted({ onManageReceipts: handleManageReceipts, sort, toggleSort, showRate })}
            data={paidWithdrawsData.items}
            cardClasses="border-0"
            onPageChange={methods.handlePageChange}
            skip={skip}
            totalItems={paidWithdrawsData.count}
            mobileCards={paidWithdrawsData.items.map((el) => (
              <MobileBlockTraderWithdraw key={el.id} withdraw={el} />
            ))}
          />
          {selectedWithdrawId && (
            <ManageReceiptsDialog
              isOpen={isReceiptsDialogOpen}
              onClose={handleCloseReceiptsDialog}
              withdrawId={selectedWithdrawId}
            />
          )}
        </>
      )}
    </div>
  )
}
